import script from "./AddNewRequisitionPO.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewRequisitionPO.vue?vue&type=script&setup=true&lang=js"

import "./AddNewRequisitionPO.vue?vue&type=style&index=0&id=124ab4ac&lang=css"

const __exports__ = script;

export default __exports__